import React from 'react';
import { Box, Typography } from '@mui/material';
import { businessInfo } from '../config/info';

const MapSection = () => {
  const url = businessInfo.mapEmbedUrl;
  if (!url || !url.trim()) return null;

  return (
    <Box
      id="map"
      sx={{
        py: { xs: 6, md: 8 },
        px: 3,
        bgcolor: 'var(--color-cream)',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Typography
          variant="overline"
          sx={{ letterSpacing: 3, color: 'var(--color-warm-gray)', fontWeight: 500, fontSize: '0.85rem' }}
        >
          Location
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 500,
            mt: 1,
            mb: 3,
            color: 'var(--color-charcoal)',
          }}
        >
          Find us
        </Typography>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '50%',
            borderRadius: 2,
            overflow: 'hidden',
            border: '1px solid var(--color-sand)',
          }}
        >
          <Box
            component="iframe"
            src={url}
            title="Chan's Nest Inn location map — Sholayar Dam, Valparai 642125"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MapSection;
